import * as React from 'react';

import {setBodyId} from '../../../dom';

import {PageContainer, PageTitleBar} from '../../layout';

import {DomainsPage} from './domains-page';

/**
 * Wrapper for the domains page that allows it to render as a complete
 * page outside of the setup context. We use this for the embedded version
 * of Marketing, where we need to expose settings without the full setup
 * section.
 */
export function DomainsPageStandalone() {
    setBodyId('list-domains');

    return (
        <PageContainer
            title='Domains'
            pageTitleBar={
                <PageTitleBar
                    title='Domains'
                    subheaderPrimaryText='Add and manage your custom domains'
                />
            }
        >
            <DomainsPage />
        </PageContainer>
    );
}
